document.addEventListener('DOMContentLoaded', () => {
  const MAX_PREVIEW_COUNT = 10;
  const ENGRAVING_IMAGE_BASE_URL = 'https://cdn.shopify.com/s/files/1/0789/3142/7541/files/engraving_';
  const ENGRAVING_IMAGE_VERSION = '?v=1778210765';
  const DEFAULT_PREVIEW_TEXT = '文字を入力してください';
  const DEFAULT_COLOR_PLACEHOLDER = 'お選びください';
  const DEFAULT_VALIDATION_TEXT = '※「刻印文字」の入力がないと、「カートに追加する」ことができません。';

  /* ===============================
  要素取得
  =============================== */
  const engravingModal = document.getElementById('engraving-modal');
  const engravingAdd = document.getElementById('engraving-add');
  const engravingAction = document.querySelector('.engraving__action');

  const engravingDataInput = document.getElementById('engraving-data');
  const engravingColorInput = document.getElementById('engraving-color-data');

  const previewLabel = document.getElementById('engraving-preview-label');
  const remainingCount = document.getElementById('engraving-remaining-count');
  const deleteLastButton = document.getElementById('engraving-delete-last');

  const openButtons = document.querySelectorAll('.js-engraving-open');
  const closeButtons = document.querySelectorAll('.js-engraving-close');
  const confirmButton = document.querySelector('.engraving__confirm-button');

  const tabItems = document.querySelectorAll('.engraving__tab-item');
  const panelButtons = document.querySelectorAll('.engraving__panel button[data-img]');

  const colorSelector = document.querySelector('.engraving__color-selector');
  const colorPlaceholder = document.querySelector('.engraving__color-placeholder');
  const colorOptions = document.querySelector('.engraving__color-options');
  const colorRadios = document.querySelectorAll('input[name="engraving-color"]');

  const validationMessage = document.getElementById('engraving-validation-message');

  /* ===============================
  状態管理
  =============================== */
  const engravingItems = [];
  let selectedEngravingColor = '';

  /* ===============================
  関連フォーム / カートボタン取得
  =============================== */
  const productForm = engravingDataInput ? engravingDataInput.form : null;
  const productFormWrapper = productForm ? productForm.closest('product-form') || productForm : null;

  const cartSubmitButtons = productForm ? productForm.querySelectorAll('button[type="submit"], input[type="submit"], button[name="add"], button.product-form__submit') : [];
  /* ===============================
  共通関数
  =============================== */
  const getEngravingText = () => {
    return engravingItems.map((item) => item.engraving).join('');
  };

  const updateRemainingCount = () => {
    if (!remainingCount) return;
    remainingCount.textContent = String(MAX_PREVIEW_COUNT - engravingItems.length);
  };

  const renderPreviewImages = () => {
    if (!previewLabel) return;

    if (engravingItems.length === 0) {
      previewLabel.textContent = DEFAULT_PREVIEW_TEXT;
      return;
    }

    const imagesHtml = engravingItems
      .map((item) => {
        if(item.img.match('cdn')) {
          return `<div class="preview-image-container"><img src="${item.img}" alt=""></div>`;
        } else {
          const src = `${ENGRAVING_IMAGE_BASE_URL}${item.img}.png${ENGRAVING_IMAGE_VERSION}`;
          return `<div class="preview-image-container"><img src="${src}" alt=""></div>`;
        }
      })
      .join('');

    previewLabel.innerHTML = imagesHtml;
  };

  const syncHiddenInputs = () => {
    if (engravingDataInput) {
      engravingDataInput.value = getEngravingText();
    }

    if (engravingColorInput) {
      engravingColorInput.value = selectedEngravingColor;
    }
  };

  const updateValidationMessage = () => {
    if (!validationMessage) return;

    const engravingText = engravingDataInput ? engravingDataInput.value.trim() : '';
    const engravingColor = engravingColorInput ? engravingColorInput.value.trim() : '';

    if (!engravingText) {
      validationMessage.textContent = DEFAULT_VALIDATION_TEXT;
      return;
    }

    validationMessage.innerHTML = `
      刻印文字：${engravingText}<br>
      刻印文字カラー：${engravingColor || '未選択'}
    `;
  };

  const updateCartState = () => {
    const isEngravingChecked = engravingAdd ? engravingAdd.checked : false;
    const hasConfirmedEngraving = engravingDataInput ? engravingDataInput.value.trim() !== '' : false;

    const shouldDisableCart = isEngravingChecked && !hasConfirmedEngraving;

    // coming soon / sold out 状態のボタンは有効化しない
    const isComingSoon = productFormWrapper && productFormWrapper.dataset && productFormWrapper.dataset.comingSoon === 'true';

    cartSubmitButtons.forEach((button) => {
      if (shouldDisableCart) {
        if (!button.classList.contains('is-disabled-by-engraving')) {
          button.dataset.wasDisabledBeforeEngraving = button.disabled;
        }
        button.disabled = true;
        button.classList.add('is-disabled-by-engraving');
        button.setAttribute('aria-disabled', 'true');
      } else if (button.classList.contains('is-disabled-by-engraving')) {
        button.classList.remove('is-disabled-by-engraving');
        button.setAttribute('aria-disabled', 'false');
        if (!isComingSoon && button.dataset.wasDisabledBeforeEngraving === 'false') {
          button.disabled = false;
        }
        delete button.dataset.wasDisabledBeforeEngraving;
      }
    });

    updateProductFormVisibility();
  };

  const openModal = () => {
    if (!engravingModal) return;
    engravingModal.classList.add('is-open');
    engravingModal.focus();
    document.documentElement.classList.add('is-engraving-modal-open');
  };

  const closeModal = () => {
    if (!engravingModal) return;

    engravingModal.classList.remove('is-open');
    document.documentElement.classList.remove('is-engraving-modal-open');
  };

  const resetEngravingState = () => {
    engravingItems.length = 0;
    selectedEngravingColor = '';

    if (engravingDataInput) engravingDataInput.value = '';
    if (engravingColorInput) engravingColorInput.value = '';

    colorRadios.forEach((radio) => {
      radio.checked = false;
    });

    if (colorPlaceholder) {
      colorPlaceholder.textContent = DEFAULT_COLOR_PLACEHOLDER;
    }

    if (colorSelector) {
      colorSelector.classList.remove('is-open');
    }

    renderPreviewImages();
    updateRemainingCount();
    updateValidationMessage();
    updateCartState();
  };

  const updateProductFormVisibility = () => {
    if (!productFormWrapper) return;

    const isEngravingChecked = engravingAdd ? engravingAdd.checked : false;
    const hasConfirmedEngraving = engravingDataInput ? engravingDataInput.value.trim() !== '' : false;

    const shouldHideProductForm = isEngravingChecked && !hasConfirmedEngraving;

    productFormWrapper.style.display = shouldHideProductForm ? 'none' : '';
  };

  /* ===============================
  初期処理
  =============================== */
  if (engravingModal) {
    document.body.appendChild(engravingModal);
  }

  const toggleEngravingAction = () => {
    if (!engravingAdd || !engravingAction) return;

    const isChecked = engravingAdd.checked;
    engravingAction.classList.toggle('is-visible', isChecked);

    if (!isChecked) {
      resetEngravingState();
      closeModal();
    } else {
      updateCartState();
    }
  };

  /* ===============================
  モーダル開閉
  =============================== */
  openButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  closeButtons.forEach((btn) => {
    if (btn.classList.contains('engraving__confirm-button')) return;
    btn.addEventListener('click', closeModal);
  });

  if (confirmButton) {
    confirmButton.addEventListener('click', () => {
      syncHiddenInputs();
      updateValidationMessage();
      updateCartState();
      closeModal();
    });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  /* ===============================
  刻印チェックで入力エリア表示
  =============================== */
  if (engravingAdd && engravingAction) {
    toggleEngravingAction();
    engravingAdd.addEventListener('change', toggleEngravingAction);
  }

  /* ===============================
  タブ切り替え
  =============================== */
  const panelMap = ['engraving-panel-upper', 'engraving-panel-lower', 'engraving-panel-motif'];

  tabItems.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabItems.forEach((item) => item.classList.remove('is-active'));
      tab.classList.add('is-active');

      panelMap.forEach((id) => {
        const panel = document.getElementById(id);
        if (panel) {
          panel.classList.remove('is-active');
        }
      });

      const targetPanel = document.getElementById(panelMap[index]);
      if (targetPanel) {
        targetPanel.classList.add('is-active');
      }
    });
  });

  /* ===============================
  プレビュー画像の追加・削除
  =============================== */
  panelButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const img = button.dataset.img;
      const engraving = button.dataset.engraving;

      if (!img || !engraving) return;
      if (engravingItems.length >= MAX_PREVIEW_COUNT) return;

      engravingItems.push({
        img,
        engraving,
      });

      renderPreviewImages();
      updateRemainingCount();
    });
  });

  if (deleteLastButton) {
    deleteLastButton.addEventListener('click', () => {
      if (engravingItems.length === 0) return;

      engravingItems.pop();
      renderPreviewImages();
      updateRemainingCount();
    });
  }

  /* ===============================
  刻印カラー選択
  =============================== */
  if (colorSelector && colorPlaceholder && colorOptions && colorRadios.length > 0) {
    const setSelectedColor = (radio) => {
      if (!radio) return;

      const label = radio.closest('label');
      const labelText = label ? label.textContent.trim() : DEFAULT_COLOR_PLACEHOLDER;

      radio.checked = true;
      selectedEngravingColor = radio.value;
      colorPlaceholder.textContent = labelText;

      colorPlaceholder.dataset.engravingColor = radio.value;
    };

    colorPlaceholder.addEventListener('click', () => {
      colorSelector.classList.toggle('is-open');
    });

    colorRadios.forEach((radio) => {
      radio.addEventListener('change', () => {
        setSelectedColor(radio);
        colorSelector.classList.remove('is-open');
      });

      radio.addEventListener('click', () => {
        setSelectedColor(radio);
        colorSelector.classList.remove('is-open');
      });
    });

    colorOptions.addEventListener('click', (e) => {
      const label = e.target.closest('label');
      if (!label) return;

      const radio = label.querySelector('input[name="engraving-color"]');
      if (!radio) return;

      setSelectedColor(radio);
      colorSelector.classList.remove('is-open');
    });

    document.addEventListener('click', (e) => {
      if (!colorSelector.contains(e.target)) {
        colorSelector.classList.remove('is-open');
      }
    });

    const checkedRadio = document.querySelector('input[name="engraving-color"]:checked');
    if (checkedRadio) {
      setSelectedColor(checkedRadio);
    }
  }

  /* ===============================
  初期描画
  =============================== */
  renderPreviewImages();
  updateRemainingCount();
  updateValidationMessage();
  updateCartState();
});
